import {TagsState} from "../types/TagsState";

export const state: TagsState = {
    usersTags: null,
    sessionTags: null
}